import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
declare var createjs: any;
import { SessionService } from '../../../shared/services/session.service';


@Component({
  selector: 'app-ex-ch06-page1',
  templateUrl: './ex-ch06-page1.component.html',
  styleUrls: ['./ex-ch06-page1.component.scss']
})

export class ExCh06Page1Component implements OnInit {

  public bloburl: string;
private stage: any;
  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<ExCh06Page1Component>,
    @Inject(MAT_DIALOG_DATA) public data: string) { this.bloburl = this.sessionService.bloburl; }



  ngOnInit() {
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var strbloburl = this.sessionService.bloburl;   
    
    var stage = new createjs.Stage("fk_bdcolorcanvas");
this.stage = stage;
    createjs.Touch.enable(stage);
    createjs.MotionGuidePlugin.install();

    var fk_bdcolorcanvas: any = document.getElementById('fk_bdcolorcanvas');
    fk_bdcolorcanvas.width = 1785;
    fk_bdcolorcanvas.height = 885;
    //frame
    var bitmap = new createjs.Bitmap(strbloburl + "/Lasresan/FK/FK-RB/Exercise/Ordvaskan/Images/frame.png");
    bitmap.setTransform(0, 0, 0.992, 0.97);


    //images in rounded corner  

    var container1 = new createjs.Container();

    //declare dragger status is null before complete the drag and drop of 3 objects
    var dstatus1 = null;
    var dstatus2 = null;
    var dstatus3 = null;

    var bitmap1 = new createjs.Bitmap(strbloburl + "/Lasresan/FK/FK-RB/Exercise/Ordvaskan/Images/FK_RB_CH06_EX_img01.png");
    var maskShape1 = new createjs.Shape(new createjs.Graphics().f("#000").drawRoundRectComplex(0, 0, 440, 290, 0, 0, 10, 10));
    bitmap1.mask = maskShape1;
    container1.addChild(bitmap1);
    container1.setTransform(181, 309);

    var container2 = new createjs.Container();
    var bitmap2 = new createjs.Bitmap(strbloburl + "/Lasresan/FK/FK-RB/Exercise/Ordvaskan/Images/FK_RB_CH06_EX_img02.png");
    var maskShape2 = new createjs.Shape(new createjs.Graphics().f("#000").drawRoundRectComplex(0, 0, 440, 290, 0, 0, 10, 10));
    bitmap2.mask = maskShape2;
    container2.addChild(bitmap2);
    container2.setTransform(675, 309);

    var container3 = new createjs.Container();
    var bitmap3 = new createjs.Bitmap(strbloburl + "/Lasresan/FK/FK-RB/Exercise/Ordvaskan/Images/FK_RB_CH06_EX_img03.png");
    var maskShape3 = new createjs.Shape(new createjs.Graphics().f("#000").drawRoundRectComplex(0, 0, 440, 290, 0, 0, 10, 10));
    bitmap3.mask = maskShape3;
    container3.addChild(bitmap3);
    container3.setTransform(1168, 309);

    var bitmap4 = new createjs.Bitmap(strbloburl + "/Lasresan/FK/FK-RB/Exercise/Ordvaskan/Images/FK_RB_CH06_EX_drake.png");
    bitmap4.setTransform(600, 620, 0.7, 0.7);

    var close_bag = new Image();
    close_bag.crossOrigin = "Anonymous";
    close_bag.src = strbloburl + "/Lasresan/FK/FK-RB/Exercise/Ordvaskan/Images/close_bag.png";

    var bitmap5 = new createjs.Bitmap(close_bag);
    bitmap5.setTransform(1005, 700, 0.5, 0.5);
    bitmap5.cursor = "pointer";
    bitmap5.visible = true;

    var open_bag = new Image();
    open_bag.crossOrigin = "Anonymous";
    open_bag.src = strbloburl + "/Lasresan/FK/FK-RB/Exercise/Ordvaskan/Images/open_bag.png";

    var bitmap6 = new createjs.Bitmap(open_bag);
    bitmap6.setTransform(1005, 640, 0.5, 0.5);
    bitmap6.visible = false;

    //to show the option
    bitmap5.addEventListener("click", function (event) {
      bitmap5.visible = false;
      bitmap6.visible = true;


      arr = shuffle(arr);
      arr[0].visible = true;
      createjs.Tween.get(option1).wait(1000).to({ visible: false }, 100);
      createjs.Tween.get(arr[0])
        .wait(1000).to({
          alpha: 1, visible: true,
          guide: {
            path: [1010, 705, 930, 650, 900, 630, 880, 610, 797, 640]
          }
        }, 1000)


        .to({ x: 797, y: draggerY[0] }, 0, createjs.Ease.sineInOut);

      createjs.Tween.get(option2).wait(1500).to({ visible: true }, 50).call(text2);

      function text2() {

        option2.visible = false;
        arr[1].visible = true;
        createjs.Tween.get(arr[1])

          .to({
            alpha: 1, visible: true,
            guide: {
              path: [1010, 680, 930, 650, 900, 620, 880, 620, 797, 630]
            }
          }, 1000)

          .to({ x: 797, y: 635 }, 0).to({ x: 797, y: draggerY[1] }, 0);

      }


      createjs.Tween.get(option3).wait(1900).to({ visible: true }, 100).call(text3);
      function text3() {
        option3.visible = false;
        arr[2].visible = true;

        createjs.Tween.get(arr[2])
          .to({
            alpha: 1, visible: true,
            guide: {
              path: [1010, 720, 930, 650, 900, 630, 880, 610, 797, 625]
            }
          }, 1000)


          .to({ x: 797, y: 635 }, 0).to({ x: 797, y: draggerY[2] }, 0, createjs.Ease.getPowInOut(16))

      }

      bitmap5.cursor = 'pointer';

    })
    stage.addChild(bitmap, bitmap4, bitmap5, bitmap6);


    //rounded rectangle
    var rect_container = new createjs.Container();
    for (var i = 0; i < 3; i++) {
      var img_rect = new createjs.Shape();
      img_rect.graphics.setStrokeStyle(2).f('').beginStroke("#FFCF24").drawRoundRect(0, 0, 440, 440, 10);
      img_rect.setTransform(181 + (i * 493), 160);
      rect_container.addChild(img_rect);

    }

    var heading = new createjs.Text("Ord att förstå", "bold 40px Dk-mariken", "#FF0000");
    if (isIOS) {
      var heading = new createjs.Text("Ord att förstå", "40px Dk-mariken", "#FF0000");
      heading.outline = 2;

      var heading1 = new createjs.Text("Ord att förstå", "40px Dk-mariken", "#FF0000");
      heading1.textAlign = "center";
      heading1.setTransform(890, 80);
    }

    heading.textAlign = "center";
    heading.setTransform(890, 80);
   

    var sent1 = new createjs.Text("kan finnas på museum.", "45px MajemaSkol_Exercise_bold", "#000000");   
    sent1.textAlign = "center";
    
    sent1.textBaseline = "alphabetic";
    sent1.x = 470;
    sent1.y = 230;





    var sent2 = new createjs.Text("vad som är i paketet!", "45px MajemaSkol_Exercise_bold", "#000000");    
    sent2.textAlign = "center";    
    sent2.textBaseline = "alphabetic";
    sent2.x = 963;
    sent2.y = 230;


    var sent3 = new createjs.Text("En", "45px MajemaSkol_Exercise_bold", "#000000");   
    sent3.textAlign = "center";    
    sent3.textBaseline = "alphabetic";
    sent3.x = 1250;
    sent3.y = 230;

    var sent3a = new createjs.Text("är på jakt.", "45px MajemaSkol_Exercise_bold", "#000000");   
    sent3a.textAlign = "center";    
    sent3a.textBaseline = "alphabetic";
    sent3a.x = 1475;
    sent3a.y = 230;

    var destHeight = 70;
    var destWidth = 40;

    var RectWidth1 = 79;
    var RectHeight1 = 34;

    var RectWidth2 = 72;
    var RectHeight2 = 34;

    var RectWidth3 = 113;
    var RectHeight3 = 34;

    //label option 1
    var rect1 = new createjs.Shape();
    rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(23, 13, RectWidth1, RectHeight1);
    var label1 = new createjs.Text("Skelett", "45px MajemaSkol_Exercise_bold", "#000000");   
    label1.textAlign = "center";   
    label1.textBaseline = "alphabetic";
    label1.x = 63;
    label1.y = 36;

    var draggerY = [665, 707, 748];

    var dragger1 = new createjs.Container();    
    dragger1.visible = false;
    dragger1.alpha = 0;
    dragger1.y = draggerY[0];
    dragger1.cursor = 'pointer';
    stage.enableMouseOver(20);
    dragger1.addChild(rect1, label1);
    dragger1.setBounds(202, 107, 53, 20);


    //label option 2

    var rect2 = new createjs.Shape();
    rect2.graphics.setStrokeStyle(2).f("#FFF000").drawRect(23, 13, RectWidth2, RectHeight2);



    var label2 = new createjs.Text("Gissa", "45px MajemaSkol_Exercise_bold", "#000000");    
    label2.textAlign = "center";    
    label2.textBaseline = "alphabetic";
    label2.x = 54;
    label2.y = 36;

    var dragger2 = new createjs.Container();
    dragger2.x = 1080;
    dragger2.visible = false;
    dragger2.alpha = 0;
    dragger2.y = draggerY[1];
    dragger2.cursor = 'pointer';
    stage.enableMouseOver(20);
    dragger2.addChild(rect2, label2);
    dragger2.setBounds(617, 109, 65, 20);


    //label option 3


    var rect3 = new createjs.Shape();
    rect3.graphics.setStrokeStyle(2).f("#FFF000").drawRect(23, 13, RectWidth3, RectHeight3);

    var label3 = new createjs.Text("dinosaurie", "45px MajemaSkol_Exercise_bold", "#000000");    
    label3.textAlign = "center";    
    label3.textBaseline = "alphabetic";
    label3.x = 80;
    label3.y = 36;

    var dragger3 = new createjs.Container();
    dragger3.x = 1070;
    dragger3.visible = false;
    dragger3.alpha = 0;
    dragger3.y = draggerY[2];
    dragger3.cursor = 'pointer';
    stage.enableMouseOver(20);
    dragger3.addChild(rect3, label3);
    dragger3.setBounds(977, 108, 65, 20);


    //randomnly generate options

    function shuffle(array) {
      var currentIndex = array.length, temporaryValue, randomIndex;
      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      return array;
    }
    var arr = [dragger1, dragger2, dragger3];
    arr = shuffle(arr);   
    
 

    for (i = 0; i < arr.length; i++) {
      arr[i].y = draggerY[i];
    }

    //to set the drop position

    var valuey;
    var count = 0;
    var drag_temp = false;

    var box_Container = new createjs.Container();

    var playrect = new createjs.Shape();
    playrect.graphics.f('').s('#D3D3D3').ss(1).drawRect(0, 0, 70, 39);
    playrect.setTransform(200, 264);


    var playrect1 = new createjs.Shape();
    playrect1.graphics.f('').s('#D3D3D3').ss(1).drawRect(0, 0, 72, 39);
    playrect1.setTransform(697, 264);


    var playrect2 = new createjs.Shape();
    playrect2.graphics.f('').s('#D3D3D3').ss(1).drawRect(0, 0, 72, 39);
    playrect2.setTransform(1250, 264);


    box_Container.addChild(playrect, playrect1, playrect2);

    box_Container.setTransform(50, -62);


    //destination for all dragged objects
    var destination1 = new createjs.Container();
    destination1.x = 227;
    destination1.y = 193;
    destination1.setBounds(185, 190, 90, 20);

    var destination2 = new createjs.Container();
    destination2.x = 723;
    destination2.y = 193;
    destination2.setBounds(691, 190, 85, 10);


    var destination3 = new createjs.Container();
    destination3.x = 1261;
    destination3.y = 193;
    destination3.setBounds(1231, 190, 105, 20);



    //pressmove
    dragger1.on("pressmove", function (evt: any) {
      drag_temp = true;
      if (count == 0) {
        valuey = evt.currentTarget.y;
        count = 1;

      }
      evt.currentTarget.x = evt.stageX - (RectWidth1);
      evt.currentTarget.y = evt.stageY - (RectHeight1);
      
      if (intersect(evt.currentTarget, destination1)) {       

      } else {
        playrect.visible = true;

      }
    });

    dragger1.on("pressup", function (evt: any) {
      if (drag_temp) {
      if (intersect(evt.currentTarget, destination1)) {

        dragger1.x = destination1.x;
        dragger1.y = destination1.y;

        dragger1.mouseEnabled = false;
        playrect.visible = false;
        dstatus1 = "active";
        
      }
      else {
        createjs.Tween.get(dragger1)
          .to({ x: 797, y: valuey }, 500);



      }
      count = 0;
      valuey = dragger2.y[0];

      }

      drag_temp = false;

    });



    dragger2.on("pressmove", function (evt: any) {
      drag_temp = true;
      if (count == 0) {
        valuey = evt.currentTarget.y;
        count = 1;

      }
      evt.currentTarget.x = evt.stageX - (RectWidth2);
      evt.currentTarget.y = evt.stageY - (RectHeight2);
      
      if (intersect(evt.currentTarget, destination2)) {     


      } else {
        
        playrect1.visible = true;
      }

    });

    dragger2.on("pressup", function (evt: any) {
      if (drag_temp) {
      if (intersect(evt.currentTarget, destination2)) {
        dragger2.x = destination2.x;
        dragger2.y = destination2.y;

        dragger2.mouseEnabled = false;
        playrect1.visible = false;
        dstatus2 = "active";
        
      }
      else {
        createjs.Tween.get(dragger2)
          .to({ x: 797, y: valuey }, 500);

      }
      count = 0;
        valuey = dragger2.y[1];
      }

      drag_temp = false;
    });


    dragger3.on("pressmove", function (evt: any) {
      drag_temp = true;
      if (count == 0) {
        valuey = evt.currentTarget.y;
        count = 1;

      }
      evt.currentTarget.x = evt.stageX - (RectWidth3);
      evt.currentTarget.y = evt.stageY - (RectHeight3);
      
      if (intersect(evt.currentTarget, destination3)) {      

      } else {

        playrect2.visible = true;
      }

    });

    dragger3.on("pressup", function (evt: any) {
      if (drag_temp) {
      if (intersect(evt.currentTarget, destination3)) {
        dragger3.x = destination3.x;
        dragger3.y = destination3.y;

        dragger3.mouseEnabled = false;

        playrect2.visible = false;
        dstatus3 = "active";
        

      }
      else {
        createjs.Tween.get(dragger3)
          .to({ x: 797, y: valuey }, 500);
      }
      count = 0;
      valuey = dragger3.y[2];
        bitmap6.cursor = 'pointer';
      }

      drag_temp = false;
    });

    //when 3 drag and drops are completed,dragged objects are return to closed bag while clicking the open bag image 

    bitmap6.addEventListener("click", function (event: any) {
      if (dstatus1 == "active" && dstatus2 == "active" && dstatus3 == "active") {

        dstatus1 = null;
        dstatus2 = null;
        dstatus3 = null;



        createjs.Tween.get(bitmap5)
          .wait(800).set({ visible: true }, bitmap5);
        arr = shuffle(arr);

        createjs.Tween.get(arr[0])
          .to({ x: 1040, y: 700 }, 700).call(hide);


        createjs.Tween.get(arr[1])
          .to({ x: 1040, y: 700 }, 700).call(hide);

        createjs.Tween.get(arr[2])
          .to({ x: 1040, y: 700 }, 700).call(hide);

        createjs.Tween.get(bitmap6)
          .wait(800).set({ visible: false }, bitmap6);


        bitmap5.cursor = 'pointer';
        playrect.visible = true;
        playrect1.visible = true;
        playrect2.visible = true;

        dragger1.mouseEnabled = true;
        dragger2.mouseEnabled = true;
        dragger3.mouseEnabled = true;
      }

    });
    //hide words when its reached the closed bag    
    function hide() {

      dragger1.alpha = 0;
      dragger1.visible = false;
      dragger2.alpha = 0;
      dragger2.visible = false;
      dragger3.alpha = 0;
      dragger3.visible = false;
      bitmap6.cursor = 'default';
    }

    //appears the option when clicks the bag
    var option1 = new createjs.Container();

    var rect1_new = new createjs.Shape();
    rect1_new.graphics.setStrokeStyle(2).f("#FFF000").drawRect(23, 15, RectWidth1, RectHeight1);

    var label1_new = new createjs.Text("packar", "45px MajemaSkol_Exercise_bold", "#000000");
    label1_new.textAlign = "center";
    label1_new.y = 14;
    label1_new.x = 61;

    option1.addChild(rect1_new, label1_new);
    option1.visible = false;
    option1.setTransform(1070, 695);

    var option2 = new createjs.Container();
    var rect2_new = new createjs.Shape();
    rect2_new.graphics.setStrokeStyle(2).f("#FFF000").drawRect(17, 13, RectWidth2, RectHeight2);

    var label2_new = new createjs.Text("smörgåsar", "45px MajemaSkol_Exercise_bold", "#000000");
    label2_new.textAlign = "center";
    label2_new.y = 12.5;
    label2_new.x = 73;
    option2.addChild(rect2_new, label2_new);
    option2.alpha = 0;
    option2.setTransform(1060, 665);


    var option3 = new createjs.Container();
    var rect3_new = new createjs.Shape();
    rect3_new.graphics.setStrokeStyle(2).f("#FFF000").drawRect(24, 13, RectWidth3, RectHeight3);


    var label3_new = new createjs.Text("åker", "45px MajemaSkol_Exercise_bold", "#000000");
    label3_new.textAlign = "center";
    label3_new.y = 12.5;
    label3_new.x = 60;

    option3.addChild(rect3_new, label3_new);
    option3.visible = false;
    option3.setTransform(1070, 730);


    function intersect(obj1, obj2) {
      var objBounds1 = obj1.getBounds().clone();
      var objBounds2 = obj2.getBounds().clone();

      var pt = obj1.globalToLocal(objBounds2.x, objBounds2.y);

      var h1 = -(objBounds1.height / 2 + objBounds2.height);
      var h2 = objBounds2.width / 2;
      var w1 = -(objBounds1.width / 2 + objBounds2.width);
      var w2 = objBounds2.width / 2;


      if (pt.x > w2 || pt.x < w1) return false;
      if (pt.y > h2 || pt.y < h1) return false;

      return true;
    }


    //Adds the object into stage

    stage.addChild(container1, container2, container3, rect_container, destination1, destination2,
      destination3, dragger1, dragger2, dragger3, heading, heading1, sent1, sent2, sent3, sent3a, heading, box_Container, option1, option2, option3);
    stage.mouseMoveOutside = false;
    stage.enableMouseOver();
    createjs.Ticker.reset();
    createjs.Ticker.framerate = 60;
    createjs.Ticker.addEventListener("tick", this.stage);
    createjs.Ticker.addEventListener("tick", createjs.Tween);
    createjs.Ticker.timingMode = createjs.Ticker.RAF;
  }

  onCloseCancel() {
    createjs.Ticker.reset();
    createjs.Touch.disable(this.stage);
    createjs.Tween.removeAllTweens();
    this.stage.enableMouseOver(0);
    this.stage.clear();
    this.thisDialogRef.close('Cancel');
    let toggler: any = document.getElementById("toggler");
    if (toggler) {
      toggler.style.visibility = "visible";
    }
  }
}



